<template>
  <ContactUsComponent
    :is-visible="showContactModal"
    @close="closeContactModal"
  />
  <div class="wrapper-home">
    <MenuComponent
      logoUrl="assets/logos/LogoDarkBlue.svg"
      textColor="var(--dark-blue)"
      menuIcon="assets/icons/MenuDarkBlue.svg"
      closeIcon="assets/icons/CloseDarkBlue.svg"
    />

    <header class="header">
      <div class="header-title">
        <span class="white">AGENCIA</span>
        <span class="green">AUDIOVISUAL</span>
      </div>
    </header>

    <div class="principal-section">
      <div class="section-container">
        <div class="content-container">
          <p class="text-principal">
            ¡AUMENTA EL ALCANCE DE TUS VENTAS
            <span class="white"
              >Y DEJA DE PERDER NUEVOS CLIENTES POR DEMORAS EN LA
              PUBLICACIÓN!</span
            >
          </p>
        </div>

        <div class="media-container">
          <video
            class="section-media"
            autoplay
            muted
            loop
            playsinline
            disablepictureinpicture
            controlslist="nodownload nofullscreen noremoteplayback"
          >
            <source src="assets/home/Video1.mp4" type="video/mp4" />
          </video>
        </div>
      </div>
    </div>

    <div class="content-brands">
      <p class="title">MARCAS A LAS QUE LES AYUDAMOS A CUMPLIR SUS OBJETIVOS</p>

      <div class="brands-marquee">
        <div class="brands-row row-left" id="row-left"></div>
        <div class="brands-row row-right" id="row-right"></div>
      </div>
    </div>

    <div class="wrapper-detail">
      <p class="text1">
        Después de trabajar con más de 15 retailers descubrimos por qué muchos
        no logran crecer:
      </p>

      <p class="text2">
        NO GANA QUIEN MÁS PUBLICA, GANA QUIEN
        <span class="yellow">CONVIERTE</span>
      </p>

      <GenericButton
        text="Agenda una llamada"
        backgroundColor="var(--green)"
        textColor="var(--white)"
        shadowType="light"
        class="button"
        @click="openContactModal"
      />
    </div>

    <div class="section-container">
      <div class="media-container">
        <video
          class="section-media"
          autoplay
          muted
          loop
          playsinline
          disablepictureinpicture
          controlslist="nodownload nofullscreen noremoteplayback"
        >
          <source src="assets/home/TestimonioFarmatodo.mp4" type="video/mp4" />
        </video>
      </div>

      <div class="content-container">
        <img class="icon-quote" src="assets/home/Quotes.svg" alt="testimonio" />

        <p class="text-testimony">
          "Logramos aumentar el engagement en Farmatodo en redes sociales,
          gracias al contenido que crearon basados en el estudio de la audiencia
          y de los clientes potenciales."
        </p>

        <p class="text-author">
          — César Otálora — Líder SEO Corporativo Farmatodo
        </p>
      </div>
    </div>

    <div class="section-container reverse">
      <div class="content-container">
        <img class="icon-quote" src="assets/home/Quotes.svg" alt="testimonio" />

        <p class="text-testimony">
          "Cumplimos con la meta de publicación antes de lo esperado gracias a
          su producción, por ende logramos un 20% mas en ventas en el ultimo
          mes."
        </p>

        <p class="text-author">— Jefe Comercial Online — Alkosto</p>
      </div>

      <div class="media-container">
        <img
          class="section-media"
          src="assets/home/TestimonioAlkosto.png"
          alt="Fotografía Alkosto"
        />
      </div>
    </div>

    <div class="container-boxes">
      <div class="wrapper-box">
        <img
          src="assets/home/Icon1.svg"
          alt="Volumen de contenido"
          class="icon"
        />
        <p>
          <span class="yellow">+600%</span>
          en volumen de contenido sin perder calidad.
        </p>
      </div>
      <div class="wrapper-box">
        <img src="assets/home/Icon2.svg" alt="Visualizaciones" class="icon" />
        <p>
          Contenidos que superan los
          <span class="yellow">10M – 19M</span>
          de visualizaciones orgánicas.
        </p>
      </div>
      <div class="wrapper-box">
        <img src="assets/home/Icon3.svg" alt="Piezas publicadas" class="icon" />
        <p>
          Hasta
          <span class="yellow">+600%</span>
          en volumen de piezas publicadas sin perder calidad ni coherencia de
          marca.
        </p>
      </div>
      <div class="wrapper-box">
        <img
          src="assets/home/Icon4.svg"
          alt="Incremento reacciones"
          class="icon"
        />
        <p>
          Incremento sostenido en guardados, comentarios y clics de perfil
          <span class="yellow">(+100% a +300%)</span>
          La marca se percibe más profesional, confiable y valiosa.
        </p>
      </div>
    </div>

    <div class="wrapper-detail">
      <p class="text1">Agenda tu llamada de diagnóstico</p>

      <p class="text2">
        EMPEZAREMOS A CONVERTIRTE EN EL
        <span class="yellow">MEJOR SELLER</span> DEL MERCADO
      </p>

      <GenericButton
        text="Agenda una llamada"
        backgroundColor="var(--green)"
        textColor="var(--white)"
        shadowType="light"
        class="button"
        @click="openContactModal"
      />
    </div>

    <div class="container-steps">
      <div class="wrapper-step">
        <div class="step-header">
          <div class="number">
            <p>1</p>
          </div>
          <img
            src="assets/home/Arrow1.svg"
            alt=""
            class="step-connector conector-right"
          />
        </div>
        <p class="name-step">Diagnóstico</p>
        <p class="text-step">
          Iniciamos con una llamada estratégica donde analizamos tu negocio, tu
          mercado y tus retos reales. Identificamos qué te está frenando en
          digital y diseñamos un plan claro para convertir tu presencia en un
          motor de crecimiento.
        </p>
      </div>

      <div class="wrapper-step">
        <div class="step-header">
          <img
            src="assets/home/Arrow2.svg"
            alt=""
            class="step-connector connector-left"
          />
          <div class="number">
            <p>2</p>
          </div>
          <img
            src="assets/home/Arrow1.svg"
            alt=""
            class="step-connector connector-right"
          />
        </div>
        <p class="name-step">Ejecución</p>
        <p class="text-step">
          Creamos tu contenido audiovisual con base en ese diagnóstico.
          Producimos fotos y videos alineados a tus objetivos y realizamos hasta
          3 rondas de ajustes en postproducción, para asegurar que cada pieza
          esté optimizada para vender, posicionar y diferenciar tu marca.
        </p>
      </div>

      <div class="wrapper-step">
        <div class="step-header">
          <img
            src="assets/home/Arrow2.svg"
            alt=""
            class="step-connector connector-left"
          />
          <div class="number">
            <p>3</p>
          </div>
        </div>
        <p class="name-step">Publicación</p>
        <p class="text-step">
          Te guiamos en la salida estratégica del contenido. Definimos qué
          publicar, cuándo y dónde, para que en pocos días empieces a ver
          tracción real: más alcance, más interés y una marca que por fin
          empieza a moverse en digital.
        </p>
      </div>
    </div>

    <div class="container">
      <div v-for="(image, index) in images" :key="index">
        <img :src="image.src" :alt="image.alt" class="file" />
      </div>
    </div>

    <FooterComponent overlayColor="var(--dark-blue)" />
  </div>
</template>

<script>
import MenuComponent from "@/ux/layout/components/MenuComponent.vue";
import { brands } from "../../data/home/brands";
import GenericButton from "../../components/commons/controls/GenericButton.vue";
import { homeGallery } from "@/data/home/homeGallery.js";
import FooterComponent from "@/ux/layout/components/FooterComponent.vue";
import ContactUsComponent from "../sharedComponents/ContactUsComponent.vue";
import { contactUsUse } from "../sharedComponents/use/contactUsUse";

export default {
  name: "HomeView",
  components: {
    MenuComponent,
    GenericButton,
    FooterComponent,
    ContactUsComponent,
  },

  mounted() {
    const rowLeft = document.getElementById("row-left");
    const rowRight = document.getElementById("row-right");
    if (!rowLeft || !rowRight) return;

    const loop = [...brands, ...brands];

    const createBrand = ({ mono, color, alt }) => {
      const brand = document.createElement("div");
      brand.className = "brand";

      const img = document.createElement("img");
      img.src = mono;
      img.alt = alt;
      img.loading = "lazy";

      const preload = new Image();
      preload.src = color;

      brand.appendChild(img);

      brand.addEventListener("mouseenter", () => (img.src = color));
      brand.addEventListener("mouseleave", () => (img.src = mono));

      return brand;
    };

    const offsetRight = Math.floor(brands.length / 2);

    loop.forEach((_, i) => {
      rowLeft.appendChild(createBrand(loop[i % loop.length]));
    });

    loop.forEach((_, i) => {
      rowRight.appendChild(createBrand(loop[(i + offsetRight) % loop.length]));
    });
  },

  data() {
    return {
      images: homeGallery,
    };
  },

  setup() {
    const { showContactModal, openContactModal, closeContactModal } =
      contactUsUse();

    return {
      showContactModal,
      openContactModal,
      closeContactModal,
    };
  },
};
</script>

<style scoped lang="scss">
@import "src/ux/home/styles/homeStyle";
</style>
